import { IUser, Route } from "@edgetier/watchtower-types";
import { axios } from "utilities/axios";

export const requestUser = async () => {
    const response = await axios.get<IUser>(Route.UsersMe);
    return response.data;
};
